/* eslint-disable camelcase */
import moment from 'moment';
import { createSelector } from 'reselect';
import configSelector from './config';

const selectStatusesData = createSelector(
  (state) => state.reportStatuses.payload,
  (state, key) => key,
  (payload, key) => payload[key],
);

export default createSelector(
  selectStatusesData,
  configSelector,
  (payload, { languageCode }) => {
    moment.locale(languageCode);

    const data = payload?.data;

    if (!data || !data.length) return [];

    data
      .sort(
        (a, b) =>
          moment(a.date, 'YYYY-MM-DD').format('YYYYMMDD') -
          moment(b.date, 'YYYY-MM-DD').format('YYYYMMDD'),
      )
      .reverse();

    const maxDay = moment(data[0].date, 'YYYY-MM-DD').subtract(3, 'day');

    return data.map((item) => {
      const { date } = item;

      if (moment(date, 'YYYY-MM-DD').isAfter(maxDay)) {
        return { ...item, lastDays: true };
      }

      return item;
    });
  },
);
